module.exports = __webpack_public_path__ + "img/facebook-social.851728ba.svg";